import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index1.css'; // 默认主题

// import './assets/css/theme-green/xiaolin.css'; // 浅绿色主题


// ------------------------------------------------------下面写法导致小琳代驾登录后样式对，刷新后，不存在source就导致了样式不对
// 假设有两个CSS文件：style1.css 和 style2.css
// 你想根据某个条件来决定加载哪一个

// const condition = false; // 这里的条件可以根据你的逻辑来设置
// const cssFile = condition ? 'index1.css' : 'xiaolin.css';

// // 使用动态import加载CSS文件
// import (`./assets/css/theme-green/${cssFile}`).then((module) => {
//     // 创建并插入style标签
//     const style = document.createElement('style');
//     style.textContent = module.default;
//     document.head.appendChild(style);
// });
// ------------------------------------------------------解决上述问题
let locationHref = location.href; //获取url地址

let codeStr = 'source=';
let locationIndex = locationHref.indexOf(codeStr); //获取source=的索引，如果该值大于0 代表URL中存在拼接的参数，则把拼接的参数存到source中
console.log(locationIndex, 'locationIndex');
if (locationIndex > 0) {
    let source = locationHref.slice(locationIndex + codeStr.length);
    const cssFile = source == 'xiaolin' ? 'xiaolin.css' : 'index1.css';
    // locationIndex不等于-1就代表地址拼接了source,那就判断拼接的source是否为xiaolin,逻辑在if的上面,写在if上面是因为if里面用到了locationIndex
    import (`./assets/css/theme-green/${cssFile}`).then((module) => {
        // 创建并插入style标签
        const style = document.createElement('style');
        style.textContent = module.default;
        document.head.appendChild(style);
    });

} else {
    // 系统登录页面白页并报错Cannot read properties of null (reading 'source')，下面的代码无法执行，因为没登录，没有缓存
    // 耿师傅或者小琳代驾等其他代驾登录后，地址栏没有source情况
    // let loSource = JSON.parse(localStorage.getItem('cityInfo')).source; // 登录后缓存source,这里拿到缓存的source locationIndex == -1就是耿师傅，当前行省略
    // let loCssFile = loSource == 'xiaolin' ? 'xiaolin.css' : 'index1.css'; // 如果缓存的source是xiaolin就用xiaolin.css，否则就用耿师傅的 locationIndex == -1就是耿师傅，当前行省略
    let loCssFile = 'index1.css'



    import (`./assets/css/theme-green/${loCssFile}`).then((module) => {
        // 创建并插入style标签
        const style = document.createElement('style');
        style.textContent = module.default;
        document.head.appendChild(style);
    });

}

// 使用动态import加载CSS文件
// if (locationIndex == -1) {
//     // 系统登录页面白页并报错Cannot read properties of null (reading 'source')，下面的代码无法执行，因为没登录，没有缓存
//     // 耿师傅或者小琳代驾等其他代驾登录后，地址栏没有source情况
//     // let loSource = JSON.parse(localStorage.getItem('cityInfo')).source; // 登录后缓存source,这里拿到缓存的source locationIndex == -1就是耿师傅，当前行省略
//     // let loCssFile = loSource == 'xiaolin' ? 'xiaolin.css' : 'index1.css'; // 如果缓存的source是xiaolin就用xiaolin.css，否则就用耿师傅的 locationIndex == -1就是耿师傅，当前行省略
//     let loCssFile = 'index1.css'



//     import (`./assets/css/theme-green/${loCssFile}`).then((module) => {
//         // 创建并插入style标签
//         const style = document.createElement('style');
//         style.textContent = module.default;
//         document.head.appendChild(style);
//     });
// } else {
//     // locationIndex不等于-1就代表地址拼接了source,那就判断拼接的source是否为xiaolin,逻辑在if的上面,写在if上面是因为if里面用到了locationIndex
//     import (`./assets/css/theme-green/${cssFile}`).then((module) => {
//         // 创建并插入style标签
//         const style = document.createElement('style');
//         style.textContent = module.default;
//         document.head.appendChild(style);
//     });
// }



import './assets/css/icon.css';
import 'babel-polyfill';
import {
    post
} from './utils/http';
import {
    config
} from './utils/config';

import pages from './components/mine/pages.vue';
import selectPages from './components/mine/selectPages.vue';
import '@/assets/iconfont/iconfont.css';
import global from './utils/global.js';
// import * as voicePromptFun from './utils/voicePrompt';
// 百度语音
import * as bttsFun from './utils/baidu_tts_cors';
// 全局自定义组件 --对话框保存按钮
import submitBtn from './components/common/submitBtn';
import bus from './components/common/bus';
import axios from 'axios'; // AJAX封装类
// 全部路由数据
import { allNav } from './router/routerData';

// 引入新订单需要协助指派音频文件
import needDriverAudio from '@/assets/need-driver.mp3'
let audio = null;


// const synth = window.speechSynthesis;
// const msg = new SpeechSynthesisUtterance();
//
// // 语音播报方法
// Vue.prototype.$handleSpeak = function(text) {
//     console.log(text);
//     msg.text = text;     // 文字内容
//     msg.lang = "zh-CN";  // 使用的语言:中文
//     msg.volume = 1;      // 声音音量：1
//     msg.rate = 1.5;        // 语速：1
//     msg.pitch = 1;       // 音高：1
//     synth.speak(msg);    // 播放
// }

Vue.component("submitBtn", submitBtn); //全局自定义组件 --对话框保存按钮

// 两个CSS文件：index1.css(耿师傅代驾主题) 和 xiaolin.css(小琳代驾主题)
// 根据全局变量 themeName 来决定引入哪一个
//  设置全局变量 themeName
// Vue.prototype.$themeName = 'index1'; // 可以是 'index1' 或 'xiaolin',去App.vue

Vue.prototype.$btts = bttsFun.btts; //百度语音提醒
// Vue.prototype.voicePrompt = voicePromptFun.voicePrompt; //语音提醒

Vue.prototype.global = global;


Vue.component('pages', pages);
Vue.component('selectPages', selectPages);
Vue.prototype.$post = post;
Vue.prototype.config = config;

//地图，三级联动声明      围栏功能
AMap.plugin(['AMap.DistrictSearch', 'AMap.PolyEditor']);


Vue.config.productionTip = false;
Vue.use(ElementUI, {
    size: 'small'
});


Vue.prototype.$hash_key = function(mode = 'none') {


    //hash创造

    var time = Math.round(new Date() / 1000) + Number(sessionStorage.getItem('time_difference'));


    time = time.toString();


    var hash = hex_md5(hex_md5(time + config.hash_key));


    var num1 = Math.ceil(Math.random() * 9);
    var num2 = Math.ceil(Math.random() * 9);
    var num3 = Math.ceil(Math.random() * 9);
    var num4 = Math.ceil(Math.random() * 9);

    var str = num1.toString() + num2.toString() + num3.toString() + num4.toString() + time.slice(-2, -1) + time.slice(-1) + hash.slice(num1, num1 + 1) + hash.slice(num2, num2 + 1) + hash.slice(num3, num3 + 1) + hash.slice(num4, num4 + 1);

    return str;


};

// 定义全局方法-------拼接socket链接地址
Vue.prototype.$getSocketUrl = function() {


    var socket_url = config.webSocket + 'port=admin&platform=pc&hash_key=' + this.$hash_key() + '&token=' + localStorage.getItem(config.localStorage_token_name) + '&city_tag=' + localStorage.getItem('city_tag');

    return socket_url;


};


var notify, notify_run;
// 定义全局方法-----用来检测司机上线下线状态来弹出提示框
Vue.prototype.$driverState = function(resData, broadcast_value) {
    broadcast_value = JSON.parse(localStorage.getItem('broadcast_value'));


    if (resData.identification == 'driver_online' && resData.header == 'success' && broadcast_value.driver_online && broadcast_value.driver_online != null) {

        // 接收到司机上线数据
        // this.voicePrompt(resData.msg);
        if (notify) {

            notify.close();

        }
        notify = this.$notify({
            message: resData.msg,
            duration: 2000,
            type: 'info',
            offset: 80
        });

    } else if (resData.identification == 'driver_offline' && resData.header == 'success' && broadcast_value.driver_offline && broadcast_value.driver_offline != null) {

        // 接收到司机下线数据
        // this.voicePrompt(resData.msg);
        if (notify) {

            notify.close();

        }
        notify = this.$notify({
            message: resData.msg,
            duration: 3000,
            type: 'info',
            offset: 80
        });

    } else if (resData.identification == 'need_driver' && resData.header == 'wait' && broadcast_value.need_driver && broadcast_value.need_driver != null) {
        // 接收到待派单数据
        // this.$btts({
        //     tex: '有新订单需要协助指派',
        //     tok: localStorage.getItem('bdToken'),

        // }, {
        //     volume: 0.3,
        //     autoDestory: true,
        //     timeout: 10000,
        //     hidden: false,
        //     onInit: function(htmlAudioElement) {

        //     },
        //     onSuccess: function(htmlAudioElement) {
        //         htmlAudioElement.className = 'baidu'
        //         htmlAudioElement.play()

        //     },
        //     onError: function(text) {

        //     },
        //     onTimeout: function() {

        //     }
        // });

        if (audio != null) {
            audio.pause();
        }
        audio = new Audio();
        audio.src = needDriverAudio;
        // audio.loop = "loop";
        audio.play();
        // this.$handleSpeak('有新订单需要协助指派');
        // this.voicePrompt('有新订单需要协助指派');

        if (notify) {

            notify.close();

        }
        notify = this.$notify({
            message: resData.msg,
            duration: 2000,
            type: 'info',
            offset: 80
        });

    } else if (resData.identification == 'need_legwork_driver' && resData.header == 'wait') {

        // this.voicePrompt(resData.msg);
        this.$btts({
            tex: '有跑腿订单需要协助指派',
            tok: localStorage.getItem('bdToken'),

        }, {
            volume: 0.3,
            autoDestory: true,
            timeout: 10000,
            hidden: false,
            onInit: function(htmlAudioElement) {

            },
            onSuccess: function(htmlAudioElement) {
                htmlAudioElement.className = 'baidu'
                htmlAudioElement.play()

            },
            onError: function(text) {

            },
            onTimeout: function() {

            }
        });
        // this.$handleSpeak('有跑腿订单需要协助指派');
        // 接收到跑腿协助指派
        if (notify_run) {

            notify_run.close();

        }
        notify_run = this.$notify({
            message: '有跑腿订单需要协助指派！！！',
            duration: 0,
            type: 'info',
            offset: 80
        });




    } else if (resData.identification == 'need_inspection_driver' && resData.header == 'wait') {
        // this.voicePrompt(resData.msg);
        this.$btts({
            tex: resData.msg,
            tok: localStorage.getItem('bdToken'),

        }, {
            volume: 0.3,
            autoDestory: true,
            timeout: 10000,
            hidden: false,
            onInit: function(htmlAudioElement) {

            },
            onSuccess: function(htmlAudioElement) {
                htmlAudioElement.className = 'baidu'
                htmlAudioElement.play()

            },
            onError: function(text) {

            },
            onTimeout: function() {

            }
        });
        // this.$handleSpeak(resData.msg);
        // 接收到检车协助指派
        if (notify_run) {

            notify_run.close();

        }
        notify_run = this.$notify({
            message: '有检车订单需要协助指派！！！',
            duration: 0,
            type: 'info',
            offset: 80
        });

    }


};
// 全部导航

router.onReady(() => {

    if (localStorage.getItem('access_token') == null || localStorage.getItem('access_token') == '') {

        localStorage.removeItem('access_token');
        sessionStorage.removeItem('navBar');
        next('/login');
        return;

    }

    // 有权限访问的导航
    let returnNav = JSON.parse(sessionStorage.getItem('navBar'))



    let navList = []

    for (let a = 0; a < allNav.length; a++) {

        for (let i = 0; i < returnNav.length; i++) {

            if (returnNav[i].subs) {
                //   存在二级导航

                for (let j = 0; j < returnNav[i].subs.length; j++) {

                    if (allNav[a].path === '/' + returnNav[i].subs[j].index && returnNav[i].subs[j].checked) {

                        navList.push(allNav[a])


                    } else {

                        if (returnNav[i].subs[j].subs) {

                            //   存在三级导航

                            for (let v = 0; v < returnNav[i].subs[j].subs.length; v++) {

                                if (allNav[a].path === '/' + returnNav[i].subs[j].subs[v].index && returnNav[i].subs[j].subs[v].checked) {

                                    navList.push(allNav[a])
                                }
                            }

                        }
                    }

                }

            } else {

                if (allNav[a].path === '/' + returnNav[i].index && returnNav[i].checked) {

                    navList.push(allNav[a])

                }

            }



        }


    }

    router.addRoutes([{
        path: '/',
        component: () =>
            import ( /* webpackChunkName: "home" */ '@/components/common/Home.vue'),
        meta: {
            title: '自述文件'
        },
        children: navList
    }])

    next({...to, replace: true })
})

//使用钩子函数对路由进行权限跳转
router.beforeEach(async(to, from, next) => {




    if (to.path == '/login') {

        // 跳转登录页 && token存在 && navBar数据存在

        if (localStorage.getItem('access_token') != null && sessionStorage.getItem('navBar')) {
            // token存在 && navBar数据存在
            next('/dashboard');
            console.log('存在token，跳转首页');
        } else {

            next();

        }



    } else {
        // 如果跳转非登录页


        if (localStorage.getItem('access_token') != null) {



            //登录状态



            if (sessionStorage.getItem('navBar')) {

                // 存在navBar数据

                next();


            } else {




                // 不存在navBar数据
                axios({
                    method: 'post',
                    url: config.axios_baseURL + '/system/getMenuDetails',
                    data: {
                        admin_role_code: JSON.parse(localStorage.getItem('login')).admin_role_code
                    },
                    headers: {
                        'token': localStorage.getItem(config.localStorage_token_name),
                        'city-tag': localStorage.getItem('city_tag'),
                        'hash-key': Vue.prototype.$hash_key()
                    }
                }).then(res => {

                    // token失效，返回登录页面
                    if (res.data.code == 1001) {
                        localStorage.removeItem('access_token');
                        sessionStorage.removeItem('navBar');
                        next('/login');

                    } else {

                        console.log(res.data.data);

                        sessionStorage.setItem('navBar', JSON.stringify(res.data.data));


                        // 有权限访问的导航
                        let returnNav = JSON.parse(sessionStorage.getItem('navBar'))



                        let navList = []

                        for (let a = 0; a < allNav.length; a++) {

                            for (let i = 0; i < returnNav.length; i++) {

                                if (returnNav[i].subs) {
                                    //   存在二级导航

                                    for (let j = 0; j < returnNav[i].subs.length; j++) {

                                        if (allNav[a].path === '/' + returnNav[i].subs[j].index && returnNav[i].subs[j].checked) {

                                            navList.push(allNav[a])


                                        } else {

                                            if (returnNav[i].subs[j].subs) {

                                                //   存在三级导航

                                                for (let v = 0; v < returnNav[i].subs[j].subs.length; v++) {

                                                    if (allNav[a].path === '/' + returnNav[i].subs[j].subs[v].index && returnNav[i].subs[j].subs[v].checked) {

                                                        navList.push(allNav[a])
                                                    }
                                                }

                                            }
                                        }

                                    }

                                } else {

                                    if (allNav[a].path === '/' + returnNav[i].index && returnNav[i].checked) {

                                        navList.push(allNav[a])

                                    }

                                }



                            }


                        }

                        router.addRoutes([{
                            path: '/',
                            component: () =>
                                import ( /* webpackChunkName: "home" */ '@/components/common/Home.vue'),
                            meta: {
                                title: '自述文件'
                            },
                            children: navList
                        }])

                        next({...to, replace: true })
                    }



                });

            }






        } else {

            if (sessionStorage.getItem('navBar')) {



                // 有权限访问的导航
                let returnNav = JSON.parse(sessionStorage.getItem('navBar'))



                let navList = []

                for (let a = 0; a < allNav.length; a++) {

                    for (let i = 0; i < returnNav.length; i++) {

                        if (returnNav[i].subs) {
                            //   存在二级导航

                            for (let j = 0; j < returnNav[i].subs.length; j++) {

                                if (allNav[a].path === '/' + returnNav[i].subs[j].index && returnNav[i].subs[j].checked) {

                                    navList.push(allNav[a])


                                } else {

                                    if (returnNav[i].subs[j].subs) {

                                        //   存在三级导航

                                        for (let v = 0; v < returnNav[i].subs[j].subs.length; v++) {

                                            if (allNav[a].path === '/' + returnNav[i].subs[j].subs[v].index && returnNav[i].subs[j].subs[v].checked) {

                                                navList.push(allNav[a])
                                            }
                                        }

                                    }
                                }

                            }

                        } else {

                            if (allNav[a].path === '/' + returnNav[i].index && returnNav[i].checked) {

                                navList.push(allNav[a])

                            }

                        }



                    }


                }

                router.addRoutes([{
                    path: '/',
                    component: () =>
                        import ( /* webpackChunkName: "home" */ '@/components/common/Home.vue'),
                    meta: {
                        title: '自述文件'
                    },
                    children: navList
                }])

            }


            // 未登录状态
            next('/login');



        }


    }


});


new Vue({
    router,
    render: h => h(App)
}).$mount('#app');